import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontWeight, Fonts, Spacing } from "@snapchat/snap-design-system";

export const HeaderWrapper = styled.div`
    ${Fonts.Paragraph.P300};
    margin-bottom: ${Spacing.MD}px;
    color: ${Colors.WHITE};
`;

export const Subheading = styled.div`
    ${Fonts.Paragraph.P300};
    font-weight: ${FontWeight.MEDIUM};
    color: ${Colors.WHITE};
`;

export const overrideMarginBottom = css`
    &.distribution-restriction-header.tooltip-header {
        margin-top: 0;
        margin-bottom: ${Spacing.XS}px;
    }
`;

export const linkButton = css`
    display: inline;

    &.sds-base-button.ant-btn {
        display: inline;

        min-height: unset;
        padding: 0;

        ${Fonts.Paragraph.P300};
        color: ${Colors.Blue.V100};
        vertical-align: baseline;
    }
`;
